module.exports = __webpack_public_path__ + "static/media/Asset5APZ1.f80dbdc6.png";